import { getResumePolicy } from '@/api/modules/campus'
import { generateUniqueFileName } from '@/utils/fileNameUtils'

/**
 * 简历 OSS 上传（凭证接口：v1/user/campus/resume/getResumePolicy）
 */
export function useOssUpload() {
  const aliOssUpload = async (fileName, file) => {
    const uniqueFileName = generateUniqueFileName(fileName || file.name)
    const { data } = await getResumePolicy()

    const uploadFileAppend = {
      key: `${data.dir}${uniqueFileName}`,
      policy: data.policy,
      OSSAccessKeyId: data.accessid,
      success_action_status: '200',
      signature: data.signature,
      file
    }

    const formData = new FormData()
    Object.keys(uploadFileAppend).forEach(key => {
      if (key === 'file') {
        formData.append('file', uploadFileAppend[key])
      } else {
        formData.append(key, String(uploadFileAppend[key]))
      }
    })

    const response = await fetch(data.host, {
      method: 'POST',
      body: formData
    })

    if (!response.ok) {
      throw new Error('Upload failed')
    }

    const url = `${data.host}/${data.dir}${uniqueFileName}`
    return {
      fileName: fileName || file.name,
      fileUrl: url
    }
  }

  return {
    aliOssUpload
  }
}

export default useOssUpload
